export default {"src":"/_next/static/media/KeyboardArrowRight.4b206368.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};